export const match = (param: string) => {
	return param.startsWith('@')
}
